var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatrix1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 135,
    viewBox: "0 0 4 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 0.83L3.4702 0H0.200195L1.0202 0.83H2.6402Z",
    fill: "url(#paint0_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 3.85995V5.47995L3.65984 6.30995V3.85995L3.24985 3.44995L2.83984 3.85995Z",
    fill: "url(#paint1_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 5.67993L0.200195 6.49993H3.4702L2.6402 5.67993H1.0202Z",
    fill: "url(#paint2_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 2.84009L0.610352 3.25009L1.02035 3.67009H2.64035L3.06035 3.25009L2.64035 2.84009H1.02035Z",
    fill: "url(#paint3_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.199951V2.23995V2.64995L0.409996 3.05995L0.830002 2.64995V2.23995V1.01995L0 0.199951Z",
    fill: "url(#paint4_linear_2368_121710)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 38.4001L3.4702 37.5801H0.200195L1.0202 38.4001H2.6402Z",
    fill: "url(#paint5_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 41.43V43.06L3.65984 43.88V41.43L3.24985 41.02L2.83984 41.43Z",
    fill: "url(#paint6_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 43.25L0.200195 44.07H3.4702L2.6402 43.25H1.0202Z",
    fill: "url(#paint7_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 40.4102L0.610352 40.8302L1.02035 41.2402H2.64035L3.06035 40.8302L2.64035 40.4102H1.02035Z",
    fill: "url(#paint8_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 38.6L0 37.77V40.22L0.409996 40.63L0.830002 40.22V39.82V38.6Z",
    fill: "url(#paint9_linear_2368_121710)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 30.8901L3.4702 30.0601H0.200195L1.0202 30.8901H2.6402Z",
    fill: "url(#paint10_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 32.71L3.24985 33.12L3.65984 32.71V30.26L2.83984 31.08V32.71Z",
    fill: "url(#paint11_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 35.74L0.200195 36.56H3.4702L2.6402 35.74H1.0202Z",
    fill: "url(#paint12_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 33.92L0.409996 33.51L0 33.92V36.37L0.830002 35.54V33.92Z",
    fill: "url(#paint13_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 32.9001L0.610352 33.3101L1.02035 33.7201H2.64035L3.06035 33.3101L2.64035 32.9001H1.02035Z",
    fill: "url(#paint14_linear_2368_121710)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 25.19L3.24985 25.6L3.65984 25.19V22.74L2.83984 23.57V25.19Z",
    fill: "url(#paint15_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 26.4V28.03L3.65984 28.85V26.4L3.24985 25.99L2.83984 26.4Z",
    fill: "url(#paint16_linear_2368_121710)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 62.7601L3.24985 63.1801L3.65984 62.7601V60.3201L2.83984 61.1401V62.7601Z",
    fill: "url(#paint17_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 63.9801V65.6001L3.65984 66.4201V63.9801L3.24985 63.5601L2.83984 63.9801Z",
    fill: "url(#paint18_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 62.96L0.610352 63.37L1.02035 63.78H2.64035L3.06035 63.37L2.64035 62.96H1.02035Z",
    fill: "url(#paint19_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 61.1401L0 60.3201V62.7601L0.409996 63.1801L0.830002 62.7601V62.3601V61.1401Z",
    fill: "url(#paint20_linear_2368_121710)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 53.4299L3.4702 52.6099H0.200195L1.0202 53.4299H2.6402Z",
    fill: "url(#paint21_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 56.4598V58.0898L3.65984 58.9098V56.4598L3.24985 56.0498L2.83984 56.4598Z",
    fill: "url(#paint22_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 58.2798L0.200195 59.0998H3.4702L2.6402 58.2798H1.0202Z",
    fill: "url(#paint23_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 55.4399L0.610352 55.8599L1.02035 56.2699H2.64035L3.06035 55.8599L2.64035 55.4399H1.02035Z",
    fill: "url(#paint24_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 53.6198L0 52.7998V55.2498L0.409996 55.6598L0.830002 55.2498V54.8498V53.6198Z",
    fill: "url(#paint25_linear_2368_121710)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 47.73L3.24985 48.15L3.65984 47.73V45.29L2.83984 46.11V47.73Z",
    fill: "url(#paint26_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 48.95V50.57L3.65984 51.4V48.95L3.24985 48.53L2.83984 48.95Z",
    fill: "url(#paint27_linear_2368_121710)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 83.4899L3.4702 82.6699H0.200195L1.0202 83.4899H2.6402Z",
    fill: "url(#paint28_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 85.3099L3.24985 85.7199L3.65984 85.3099V82.8599L2.83984 83.6799V85.3099Z",
    fill: "url(#paint29_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 86.5199V88.1399L3.65984 88.9699V86.5199L3.24985 86.1099L2.83984 86.5199Z",
    fill: "url(#paint30_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 88.3398L0.200195 89.1598H3.4702L2.6402 88.3398H1.0202Z",
    fill: "url(#paint31_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 85.5L0.610352 85.91L1.02035 86.33H2.64035L3.06035 85.91L2.64035 85.5H1.02035Z",
    fill: "url(#paint32_linear_2368_121710)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 77.7901L3.24985 78.2001L3.65984 77.7901V75.3401L2.83984 76.1701V77.7901Z",
    fill: "url(#paint33_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 79.0001V80.6301L3.65984 81.4501V79.0001L3.24985 78.5901L2.83984 79.0001Z",
    fill: "url(#paint34_linear_2368_121710)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 68.4599L3.4702 67.6399H0.200195L1.0202 68.4599H2.6402Z",
    fill: "url(#paint35_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 70.2798L3.24985 70.6898L3.65984 70.2798V67.8298L2.83984 68.6498V70.2798Z",
    fill: "url(#paint36_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 71.4898V73.1198L3.65984 73.9398V71.4898L3.24985 71.0798L2.83984 71.4898Z",
    fill: "url(#paint37_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 73.3098L0.200195 74.1298H3.4702L2.6402 73.3098H1.0202Z",
    fill: "url(#paint38_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 70.47L0.610352 70.88L1.02035 71.3H2.64035L3.06035 70.88L2.64035 70.47H1.02035Z",
    fill: "url(#paint39_linear_2368_121710)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 101.82L3.4702 101H0.200195L1.0202 101.82H2.6402Z",
    fill: "url(#paint40_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 103.64L3.24985 104.05L3.65984 103.64V101.19L2.83984 102.02V103.64Z",
    fill: "url(#paint41_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 104.85V106.48L3.65984 107.3V104.85L3.24985 104.44L2.83984 104.85Z",
    fill: "url(#paint42_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 106.67L0.200195 107.5H3.4702L2.6402 106.67H1.0202Z",
    fill: "url(#paint43_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 104.85L0.409996 104.44L0 104.85V107.3L0.830002 106.48V104.85Z",
    fill: "url(#paint44_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 103.84L0.610352 104.25L1.02035 104.66H2.64035L3.06035 104.25L2.64035 103.84H1.02035Z",
    fill: "url(#paint45_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 102.02L0 101.19V103.64L0.409996 104.05L0.830002 103.64V103.24V102.02Z",
    fill: "url(#paint46_linear_2368_121710)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 92.83L3.4702 92H0.200195L1.0202 92.83H2.6402Z",
    fill: "url(#paint47_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 95.86V97.4799L3.65984 98.31V95.86L3.24985 95.45L2.83984 95.86Z",
    fill: "url(#paint48_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 97.6799L0.200195 98.4999H3.4702L2.6402 97.6799H1.0202Z",
    fill: "url(#paint49_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 95.86L0.409996 95.45L0 95.86V98.31L0.830002 97.4799V95.86Z",
    fill: "url(#paint50_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 94.8401L0.610352 95.2501L1.02035 95.6601H2.64035L3.06035 95.2501L2.64035 94.8401H1.02035Z",
    fill: "url(#paint51_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 93.02L0 92.2V94.65L0.409996 95.06L0.830002 94.65V94.24V93.02Z",
    fill: "url(#paint52_linear_2368_121710)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 90.9999L3.4702 90.1799H0.200195L1.0202 90.9999H2.6402Z",
    fill: "url(#paint53_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 94.0299V95.6599L3.65984 96.4799V94.0299L3.24985 93.6199L2.83984 94.0299Z",
    fill: "url(#paint54_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 95.8499L0.200195 96.6799H3.4702L2.6402 95.8499H1.0202Z",
    fill: "url(#paint55_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 93.02L0.610352 93.43L1.02035 93.84H2.64035L3.06035 93.43L2.64035 93.02H1.02035Z",
    fill: "url(#paint56_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90.3699V92.4199V92.8199L0.409996 93.2299L0.830002 92.8199V92.4199V91.1999L0 90.3699Z",
    fill: "url(#paint57_linear_2368_121710)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 128.58L3.4702 127.75H0.200195L1.0202 128.58H2.6402Z",
    fill: "url(#paint58_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 130.4L3.24985 130.81L3.65984 130.4V127.95L2.83984 128.77V130.4Z",
    fill: "url(#paint59_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 131.61V133.23L3.65984 134.06V131.61L3.24985 131.2L2.83984 131.61Z",
    fill: "url(#paint60_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 133.43L0.200195 134.25H3.4702L2.6402 133.43H1.0202Z",
    fill: "url(#paint61_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 131.61L0.409996 131.2L0 131.61V134.06L0.830002 133.23V131.61Z",
    fill: "url(#paint62_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 130.59L0.610352 131L1.02035 131.41H2.64035L3.06035 131L2.64035 130.59H1.02035Z",
    fill: "url(#paint63_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 128.77L0 127.95V130.4L0.409996 130.81L0.830002 130.4V129.99V128.77Z",
    fill: "url(#paint64_linear_2368_121710)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 118.82L3.4702 118H0.200195L1.0202 118.82H2.6402Z",
    fill: "url(#paint65_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 120.64L3.24985 121.05L3.65984 120.64V118.19L2.83984 119.02V120.64Z",
    fill: "url(#paint66_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 121.85V123.48L3.65984 124.3V121.85L3.24985 121.44L2.83984 121.85Z",
    fill: "url(#paint67_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 123.67L0.200195 124.5H3.4702L2.6402 123.67H1.0202Z",
    fill: "url(#paint68_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 120.83L0.610352 121.25L1.02035 121.66H2.64035L3.06035 121.25L2.64035 120.83H1.02035Z",
    fill: "url(#paint69_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 119.02L0 118.19V120.64L0.409996 121.05L0.830002 120.64V120.24V119.02Z",
    fill: "url(#paint70_linear_2368_121710)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.83
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6402 110.83L3.4702 110H0.200195L1.0202 110.83H2.6402Z",
    fill: "url(#paint71_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83984 112.65L3.24985 113.06L3.65984 112.65V110.2L2.83984 111.02V112.65Z",
    fill: "url(#paint72_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0202 115.68L0.200195 116.5H3.4702L2.6402 115.68H1.0202Z",
    fill: "url(#paint73_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.830002 113.86L0.409996 113.45L0 113.86V116.31L0.830002 115.48V113.86Z",
    fill: "url(#paint74_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02035 112.84L0.610352 113.25L1.02035 113.66H2.64035L3.06035 113.25L2.64035 112.84H1.02035Z",
    fill: "url(#paint75_linear_2368_121710)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74011 9.53998L3.28012 9H1.12012L1.6701 9.53998H2.74011Z",
    fill: "url(#paint76_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87012 10.7401L3.14011 11.0101L3.41013 10.7401V9.12012L2.87012 9.6701V10.7401Z",
    fill: "url(#paint77_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87012 11.54V12.61L3.41013 13.15V11.54L3.14011 11.27L2.87012 11.54Z",
    fill: "url(#paint78_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6701 12.74L1.12012 13.28H3.28012L2.74011 12.74H1.6701Z",
    fill: "url(#paint79_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54001 11.54L1.26999 11.27L1 11.54V13.15L1.54001 12.61V11.54Z",
    fill: "url(#paint80_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.67038 10.8701L1.40039 11.1401L1.67038 11.4101H2.74039L3.01038 11.1401L2.74039 10.8701H1.67038Z",
    fill: "url(#paint81_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.54001 9.6701L1 9.12012V10.7401L1.26999 11.0101L1.54001 10.7401V10.4701V9.6701Z",
    fill: "url(#paint82_linear_2368_121710)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.93039 16.6L3.54037 16H1.15039L1.7504 16.6H2.93039Z",
    fill: "url(#paint83_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08008 17.9299L3.3801 18.2299L3.68008 17.9299V16.1399L3.08008 16.7399V17.9299Z",
    fill: "url(#paint84_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7504 20.1399L1.15039 20.7399H3.54037L2.93039 20.1399H1.7504Z",
    fill: "url(#paint85_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.60999 18.81L1.31 18.51L1 18.81V20.6L1.60999 20V18.81Z",
    fill: "url(#paint86_linear_2368_121710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75021 18.0701L1.4502 18.3701L1.75021 18.6701H2.93021L3.23019 18.3701L2.93021 18.0701H1.75021Z",
    fill: "url(#paint87_linear_2368_121710)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.88005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.88007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.87991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2368_121710",
    x1: 0.41,
    y1: 135.25,
    x2: 0.41,
    y2: -1.88005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.87991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.87999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.88999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.87993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2368_121710",
    x1: 0.41,
    y1: 135.25,
    x2: 0.41,
    y2: -1.87999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2368_121710",
    x1: 1.8302,
    y1: 135.23,
    x2: 1.8302,
    y2: -1.87994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2368_121710",
    x1: 3.24984,
    y1: 135.24,
    x2: 3.24984,
    y2: -1.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2368_121710",
    x1: 1.8302,
    y1: 135.24,
    x2: 1.8302,
    y2: -1.87999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2368_121710",
    x1: 0.409999,
    y1: 135.24,
    x2: 0.409999,
    y2: -1.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.87984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.87995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.87996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.87971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2368_121710",
    x1: 0.410001,
    y1: 135.25,
    x2: 0.410001,
    y2: -1.88994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.89012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.88013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.89019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.87992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2368_121710",
    x1: 0.409999,
    y1: 135.24,
    x2: 0.409999,
    y2: -1.88013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.87998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.87995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.89005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.89015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.88016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2368_121710",
    x1: 1.8302,
    y1: 135.24,
    x2: 1.8302,
    y2: -1.88012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.88019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.88993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.87993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2368_121710",
    x1: 1.8302,
    y1: 135.24,
    x2: 1.8302,
    y2: -1.88008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2368_121710",
    x1: 3.24984,
    y1: 135.24,
    x2: 3.24984,
    y2: -1.88018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2368_121710",
    x1: 3.24984,
    y1: 135.24,
    x2: 3.24984,
    y2: -1.88018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2368_121710",
    x1: 1.8302,
    y1: 135.24,
    x2: 1.8302,
    y2: -1.88086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.88019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2368_121710",
    x1: 1.8302,
    y1: 131.03,
    x2: 1.8302,
    y2: -6.07996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2368_121710",
    x1: 3.24984,
    y1: 131.03,
    x2: 3.24984,
    y2: -6.09008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2368_121710",
    x1: 3.24984,
    y1: 131.03,
    x2: 3.24984,
    y2: -6.09008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2368_121710",
    x1: 1.8302,
    y1: 131.03,
    x2: 1.8302,
    y2: -6.07929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2368_121710",
    x1: 0.41,
    y1: 131.04,
    x2: 0.41,
    y2: -6.09008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2368_121710",
    x1: 1.83035,
    y1: 131.04,
    x2: 1.83035,
    y2: -6.09987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2368_121710",
    x1: 0.41,
    y1: 131.04,
    x2: 0.41,
    y2: -6.09008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2368_121710",
    x1: 1.8302,
    y1: 129.56,
    x2: 1.8302,
    y2: -7.58022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2368_121710",
    x1: 3.24984,
    y1: 129.56,
    x2: 3.24984,
    y2: -7.57007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2368_121710",
    x1: 1.8302,
    y1: 129.56,
    x2: 1.8302,
    y2: -7.58003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2368_121710",
    x1: 0.410001,
    y1: 129.56,
    x2: 0.410001,
    y2: -7.58007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2368_121710",
    x1: 1.83035,
    y1: 129.56,
    x2: 1.83035,
    y2: -7.57987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2368_121710",
    x1: 0.410001,
    y1: 129.56,
    x2: 0.410001,
    y2: -7.58007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.89004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.88015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.89036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.88994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2368_121710",
    x1: 0.409999,
    y1: 135.24,
    x2: 0.409999,
    y2: -1.88015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.89028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.89007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2368_121710",
    x1: 3.24984,
    y1: 135.25,
    x2: 3.24984,
    y2: -1.89007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2368_121710",
    x1: 1.8302,
    y1: 135.25,
    x2: 1.8302,
    y2: -1.88876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2368_121710",
    x1: 0.410001,
    y1: 135.25,
    x2: 0.410001,
    y2: -1.89007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2368_121710",
    x1: 1.83035,
    y1: 135.25,
    x2: 1.83035,
    y2: -1.8911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2368_121710",
    x1: 0.41,
    y1: 135.25,
    x2: 0.41,
    y2: -1.88008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2368_121710",
    x1: 1.8302,
    y1: 133.01,
    x2: 1.8302,
    y2: -4.12996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2368_121710",
    x1: 3.24984,
    y1: 133.01,
    x2: 3.24984,
    y2: -4.13008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2368_121710",
    x1: 3.24984,
    y1: 133.01,
    x2: 3.24984,
    y2: -4.12009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2368_121710",
    x1: 1.8302,
    y1: 133.01,
    x2: 1.8302,
    y2: -4.12918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2368_121710",
    x1: 1.83035,
    y1: 133.01,
    x2: 1.83035,
    y2: -4.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2368_121710",
    x1: 0.41,
    y1: 133.01,
    x2: 0.41,
    y2: -4.12009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2368_121710",
    x1: 1.8302,
    y1: 132.53,
    x2: 1.8302,
    y2: -4.61025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2368_121710",
    x1: 3.24984,
    y1: 132.53,
    x2: 3.24984,
    y2: -4.61007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2368_121710",
    x1: 1.8302,
    y1: 132.53,
    x2: 1.8302,
    y2: -4.61002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2368_121710",
    x1: 0.410001,
    y1: 132.53,
    x2: 0.410001,
    y2: -4.61007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2368_121710",
    x1: 1.83035,
    y1: 132.53,
    x2: 1.83035,
    y2: -4.61096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39FC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AB405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2368_121710",
    x1: 2.20012,
    y1: 173.953,
    x2: 2.20012,
    y2: 5.51014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2368_121710",
    x1: 3.14012,
    y1: 173.969,
    x2: 3.14012,
    y2: 5.51015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2368_121710",
    x1: 3.14012,
    y1: 173.96,
    x2: 3.14012,
    y2: 5.51001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2368_121710",
    x1: 2.20012,
    y1: 173.963,
    x2: 2.20012,
    y2: 5.50987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2368_121710",
    x1: 1.27001,
    y1: 173.96,
    x2: 1.27001,
    y2: 5.51001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2368_121710",
    x1: 2.20038,
    y1: 173.963,
    x2: 2.20038,
    y2: 5.51003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2368_121710",
    x1: 1.27001,
    y1: 173.959,
    x2: 1.27001,
    y2: 5.51015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#239A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#165901"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2368_121710",
    x1: 2.34038,
    y1: 23.2601,
    x2: 2.34038,
    y2: -137.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2368_121710",
    x1: 3.38008,
    y1: 23.2599,
    x2: 3.38008,
    y2: -137.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2368_121710",
    x1: 2.34038,
    y1: 23.2599,
    x2: 2.34038,
    y2: -137.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2368_121710",
    x1: 1.30999,
    y1: 23.26,
    x2: 1.30999,
    y2: -137.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2368_121710",
    x1: 2.3402,
    y1: 23.26,
    x2: 2.3402,
    y2: -137.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix1);
export default __webpack_public_path__ + "static/media/matrix-1.3198ede5671ae2f46681d8f054f2141c.svg";
export { ForwardRef as ReactComponent };